import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// react-router v8 moved the DOM-only exports (RouterProvider,
// HydratedRouter) into the `react-router/dom` entry point; everything else
// still comes from `react-router`.
import { RouterProvider } from "react-router/dom";

import { ErrorBoundary } from "./components/ErrorBoundary";
import { ToastProvider } from "./components/ui/toast-provider";
import { installChunkReloadRecovery } from "./lib/chunk-load-error";
import { SessionQueryProvider } from "./lib/supabase";
import { applyTheme, readPersistedTheme } from "./lib/theme";
import { ThemeProvider } from "./lib/theme-context";
import { createAppRouter } from "./router";
import "./styles/index.css";

// Apply the persisted theme synchronously before React mounts so the page never
// flashes the wrong color. The ThemeProvider keeps React state in sync from
// here on. See `lib/theme.ts` for the resolution order.
applyTheme(readPersistedTheme());

// Reload once when a lazy chunk of a previous build is gone after a deploy. It
// must run before the router and `createRoot`, so the listener exists before
// any lazy import can fail. See `lib/chunk-load-error.ts`.
installChunkReloadRecovery();

const router = createAppRouter();

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <SessionQueryProvider>
      <ThemeProvider>
        <ToastProvider>
          <ErrorBoundary>
            <RouterProvider router={router} />
          </ErrorBoundary>
        </ToastProvider>
      </ThemeProvider>
    </SessionQueryProvider>
  </StrictMode>,
);
